import angular from 'angular';
import expandableTable from './expandableTable';
import loanCompactDetails from './loanCompactDetails';

export default angular.module('contactLending.components', [
  expandableTable,
  loanCompactDetails,
]).name;
